export const locales = process.env.NEXT_PUBLIC_LOCALES_AVAILABLE?.split(",");
export const defaultLocale = "fr";

export const namespaces = [
  "accounts",
  "address_form",
  "addresses",
  "bal_modal",
  "brands",
  "buy_closet_items",
  "carriers",
  "cart",
  "catalog",
  "closets",
  "common",
  "feedbacks",
  "gift_cards",
  "help",
  "invoices",
  "password_retrieve",
  "product",
  "profile",
  "referrals",
  "reviews",
  "sandbox",
  "stripe",
  "suggestions",
  "swap",
  "tunnel_steps",
];
